import { ReactNode, useMemo } from 'react';
import { useCurrentUser, useAllowedModules } from '../../../shared/auth/AuthProvider';
import { resolveEffectiveHrModules } from '../../../shared/config/hrModules';
import { Header, EmptyState } from '../../../shared/components';

/**
 * Version de RequireModule para Gestion Humana (ver
 * shared/components/RequireModule.tsx para el equivalente de Control
 * Operativo). Se mantienen separados a proposito: cada aplicacion resuelve
 * sus pantallas efectivas contra su PROPIO catalogo (ver
 * shared/config/hrModules.ts) - el Rol es por aplicacion, no global.
 */
export function RequireHrModule({ moduleId, children }: { moduleId: string; children: ReactNode }) {
  const user = useCurrentUser();
  const allowedModules = useAllowedModules();
  const effective = useMemo(() => resolveEffectiveHrModules(user.role, allowedModules), [user.role, allowedModules]);

  if (!effective.includes(moduleId)) {
    return (
      <div>
        <Header title="Acceso restringido" />
        <div className="p-4">
          <EmptyState icon="🔒" title="No tienes acceso a este módulo" description="Si necesitas usarlo, pide a un administrador que te lo habilite desde Configuración > Usuarios de Gestión Humana." />
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

/** Version de RequireAdmin para Gestion Humana - Supervisor y Operador de ESTA aplicacion nunca pasan. */
export function RequireHrAdmin({ children }: { children: ReactNode }) {
  const user = useCurrentUser();

  if (user.role !== 'admin') {
    return (
      <div>
        <Header title="Acceso restringido" />
        <div className="p-4">
          <EmptyState icon="🔒" title="Solo para administradores" description="Configuración administra usuarios y roles de Gestión Humana - es exclusiva del rol Administrador de esta aplicación." />
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
